export default __webpack_public_path__ + "static/media/collection.bf211695.svg";